import type { JSX } from "preact";

type IconProps = JSX.SVGAttributes<SVGSVGElement>;

export function IcoPlus({ class: className, ...props }: IconProps) {
  return (
    <svg
      class={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="1.5"
      aria-hidden="true"
      {...props}
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 4.5v15m7.5-7.5h-15"
      />
    </svg>
  );
}
